<div class="balance-widget"
  [ngClass]="{'balance-widget--dashboard' : isDashboard}">
  @for (item of userBalanceWidgets; track item) {
    <div
      class="balance-widget__item"
      [ngClass]="'balance-widget__item--' + item.id"
      (click)="item.balanceClickHandler()">
      <div>
        <h3 [innerHTML]="item.title | translate" [ngClass]="item.valueClass"></h3>
        <h2 [ngClass]="item.valueClass">
          @if (item.value !== null && item.value !== undefined) {
            @if (item.value < 0) {
              <span>-</span>
            }
            <span [innerHTML]="currencyDisplaySymbol"></span>
            <span>{{ formatBalanceValue(item.value) }}</span>
          } @else {
            <sb-icon name="warning"
              [ngbTooltip]="'SB_Balance_Update_Warning' | translate"
              tooltipPlacement="right"
            ></sb-icon>
          }
        </h2>
      </div>
      <sb-icon [name]="item.iconName" [ngClass]="item.valueClass" overrideStyle="duotone" class="icon"></sb-icon>
    </div>
  }
</div>
